import {
    getLocalizedString,
    OwaTimeformatLocalizedStringResourceId,
} from 'owa-timeformat/lib/localization/getLocalizedString';

import MonthNamesType from '../../store/schema/MonthNamesType';

export default function getLocalizedMonth(month: MonthNamesType): string {
    return getLocalizedString(('calendarMonth_' + month) as OwaTimeformatLocalizedStringResourceId);
}
